import React, { useState } from 'react';
import { AxiosError } from 'axios';
import { IBilledOrdersTableDataSource } from '..';
import { LongSteelOrdersService } from '../../../../../../../services/LongSteelOrders';
import { IQCFileResponse } from '../../../../../../../store/ducks/long-steel-orders/types';
import {
  Container,
  DownloadLinkButton,
  CertificateIcon,
  CleanIcon
} from './styles';
import { useDispatch } from 'react-redux';
import { EToastTypes } from '../../../../../../../store/ducks/toast/types';
import { addToast } from '../../../../../../../store/ducks/toast/actions';

interface IMultipleDownloadHeaderProps {
  selectedRows: IBilledOrdersTableDataSource[];
  cleanSelectedRows(itemsToRemove?: IBilledOrdersTableDataSource[]): void;
  setIsDownloadingMultipleItems(isDownloadingMultipleItems: boolean): void;
  setErrorInRow(
    item: IBilledOrdersTableDataSource,
    scrollToRow?: boolean
  ): void;
  maxNumberOfSelectedItems: number;
}
interface File {
  cqId: string;
  deliveryItemNumber: string;
  status: 'SUCCESS' | 'FAILED';
}

const MultipleDownloadHeader: React.FC<IMultipleDownloadHeaderProps> = ({
  selectedRows,
  cleanSelectedRows,
  setIsDownloadingMultipleItems,
  setErrorInRow,
  maxNumberOfSelectedItems
}) => {
  const dispatch = useDispatch();
  const [downloadingQCs, setDownloadingQCs] = useState(false);

  const downloadMultipleQC = () => {
    setDownloadingQCs(true);
    setIsDownloadingMultipleItems(true);

    LongSteelOrdersService.downloadMultipleCQs(
      selectedRows.map((si) => si.item)
    )
      .then((cqFileResponse: IQCFileResponse) => {
        const filesResponseSuccess = cqFileResponse.qcFile.files.filter(
          (file: File) => file.status === 'SUCCESS'
        );
        if (filesResponseSuccess.length > 0) {
          downloadZipFileFromBase64String(cqFileResponse.qcFile.qcBase64File);
        }

        const filesResponseError = cqFileResponse.qcFile.files.filter(
          (file: File) => file.status === 'FAILED'
        );
        if (filesResponseError.length > 0) {
          filesResponseError.forEach((file, idx) => {
            const item = selectedRows.find(
              (row) =>
                row.item.deliveryCode === file.cqId &&
                row.item.deliveryItemCode === file.deliveryItemNumber
            );
            if (item) {
              setErrorInRow(item, idx === 0);
            }
          });

          dispatch(
            addToast({
              type: EToastTypes.DANGER,
              message: `Não foi possível baixar o Certificado de qualidade ${
                filesResponseError.length === 1
                  ? 'do item marcado'
                  : 'dos itens marcados'
              }`
            })
          );
          cleanSelectedRows(
            selectedRows.filter((row) =>
              filesResponseError.some(
                (fre) =>
                  fre.cqId === row.item.deliveryCode &&
                  row.item.deliveryItemCode === fre.deliveryItemNumber
              )
            )
          );
        } else {
          cleanSelectedRows();
        }

        setDownloadingQCs(false);
        setIsDownloadingMultipleItems(false);
      })
      .catch((err: AxiosError) => {
        console.error(err);
        dispatch(
          addToast({
            type: EToastTypes.DANGER,
            message: 'Não foi possível baixar os Certificados de qualidade.',
            durationInMS: 5000
          })
        );
        setIsDownloadingMultipleItems(false);
        setDownloadingQCs(false);
      });
  };

  const downloadZipFileFromBase64String = (base64String: string) => {
    const dataurl = 'data:text/plain;base64,' + base64String;
    const element = document.createElement('a');

    element.setAttribute('href', dataurl);
    element.setAttribute('download', `certificados-de-qualidade.zip`);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <Container>
      <div>
        <span>
          {selectedRows.length}{' '}
          {selectedRows.length > 1
            ? 'pedidos selecionados'
            : 'pedido selecionado'}
        </span>

        <DownloadLinkButton
          className="clean-button"
          onClick={() => cleanSelectedRows()}
          disabled={downloadingQCs}
        >
          <CleanIcon />
          <span>Limpar</span>
        </DownloadLinkButton>
      </div>

      <div>
        <DownloadLinkButton
          loading={downloadingQCs}
          disabled={
            downloadingQCs || selectedRows.length > maxNumberOfSelectedItems
          }
          title={
            selectedRows.length > maxNumberOfSelectedItems
              ? `Número máximo de itens por download é ${maxNumberOfSelectedItems}`
              : ''
          }
          onClick={downloadMultipleQC}
        >
          <CertificateIcon />
          <span>
            {downloadingQCs ? 'Baixando' : 'Baixar'} pasta com{' '}
            {selectedRows.length}{' '}
            {selectedRows.length > 1 ? 'certificados' : 'certificado'}
          </span>
        </DownloadLinkButton>
      </div>
    </Container>
  );
};

export default MultipleDownloadHeader;
